import { useState } from "react"
import axios from "axios";

import MapaGoogle from "../../../ClientesMapa/MapaGoogle";

export default function ClientesEventosMapa() {

    const [carregando, alterarCarregando] = useState(false);

    return (
        <></>
    )

}